var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNurseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#ED9FA6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1454 39.1812V40.0608C33.1454 41.1203 32.2878 42 31.2308 42H17.7494C16.6924 42 15.8149 41.1403 15.8149 40.0608V39.1812",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9145 39.6209H19.0656C12.4245 39.6209 7 34.1832 7 27.5261C7 26.7864 7.61822 26.1666 8.35611 26.1666H40.6438C41.3817 26.1666 42 26.7864 42 27.5261C41.9801 34.1832 36.5555 39.6209 29.9145 39.6209Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1624 17.0706C13.1624 17.0706 21.9771 18.9898 24.49 26.1667C24.49 26.1667 23.8518 16.5708 33.9629 10.0336",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2876 21.7686C18.2876 21.7686 14.6979 23.7678 12.0854 21.7686C9.47284 19.7695 7.91724 15.6712 7.91724 15.6712C7.91724 15.6712 11.7662 12.7724 16.4528 13.3522C21.1195 13.9319 21.0198 21.1089 21.0198 21.1089",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5612 21.8485C27.5612 21.8485 37.8717 20.3492 37.8318 14.0118C37.7919 7.67453 36.8546 8.33425 38.2108 6.03522C38.2108 6.03522 28.8176 5.33552 24.6495 10.1735C20.4815 15.0114 25.2079 21.1088 25.2079 21.1088",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurseIcon);
export default __webpack_public_path__ + "static/media/nurseIcon.261bd85d457def6c248cbdc785063b8d.svg";
export { ForwardRef as ReactComponent };